import React, { ReactNode } from 'react';
import { ZigTypography } from '@zignaly-open/ui';
import { TypographyProps } from '@mui/material';

export const ValueOrDash = ({
  children,
  color,
}: {
  color?: TypographyProps['color'];
  children: string | number | ReactNode;
}) => {
  return (
    <ZigTypography color={children ? color : 'neutral300'}>
      {children || <>&mdash;</>}
    </ZigTypography>
  );
};
